import styled from "styled-components";

export const MenuWrapper = styled.section`
    width: 100%;
    border-bottom: 1px solid rgba(219, 220, 224, 0.5);
    margin-top: 40px;
    margin-bottom: 24px;
    .catalogue__menu-items-wrap {
        display: flex;
        gap: 24px;
        p {
            font-weight: 700;
            padding-bottom: 10px;
            color: #979797;
            cursor: pointer;
        }
        .catalogue__menu-active {
            p {
                padding-bottom: 8px;
                color: #000;
            }
            div {
                height: 2px;
                width: 100%;
                border-radius: 4px 4px 0px 0px;
                background: #000;
            }
        }
    }
    @media (max-width: 492px) {
        width: 100%;
        overflow: auto;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE 10+ */

        &::-webkit-scrollbar {
            background: transparent; /* Chrome/Safari/Webkit */
            width: 0px;
            height: 0px;
        }
        p {
            white-space: nowrap;
        }
    }
`;

export const OrderHistoryContainer = styled.div`
    width: 100%;
    background: #f9f9f9;
    height: 100%;
`;
export const OrderHistoryWrapper = styled.div`
    width: 1040px;
    max-width: 100%;
    margin: 0 auto;
    padding: 48px 16px 0px;
`;

export const OrdersWrapper = styled.div`
    width: 100%;
    margin-top: 24px;
    position: relative;
    .catalogue__orders-header {
        padding: 12px 24px;
        background: #f1f1f1;
        height: 40px;
        h5 {
            font-size: 0.8125rem;
            font-weight: 800;
            line-height: normal;
        }
    }
`;

export const OrderCardStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    padding: 20px 0px 16px;
    cursor: pointer;
    border-bottom: 1px solid #dbdce04d;

    p {
        font-weight: 700;
    }

    .catalogue__order-card-left {
        display: flex;
        align-items: center;
        gap: 16px;
    }
    .catalogue__order-card-right {
        display: flex;
        align-items: center;
        gap: 24px;
    }
`;

export const IconWrap = styled.div`
    width: 40px;
    height: 40px;
    display: flex;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    background: ${({ bgColor }) => (bgColor ? bgColor : "#fff5db")};
`;

export const OrderDetailsOverlayWrapper = styled.div`
    position: fixed;
    z-index: 99999;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(64, 25, 109, 0.2);
    background: rgb(0, 0, 0, 0.2);
`;

export const OrderDetailsWrapper = styled.section`
    height: 100vh;
    background: #fff;
    overflow: hidden;
    margin-left: auto;
    max-width: 0px;
    -webkit-animation: slide-in-out 0.6s cubic-bezier(0.455, 0.03, 0, 1) forwards;
    /* for less modern browsers */
    animation: slide-in-out 0.6s cubic-bezier(0.455, 0.03, 0, 1) forwards;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 0px 40px;
    position: relative;

    @-webkit-keyframes slide-in-out {
        from {
            max-width: 70px;
            opacity: 0;
        }

        to {
            max-width: 400px;
            opacity: 1;
        }
    }

    @keyframes slide-in-out {
        from {
            max-width: 70px;
            opacity: 0;
        }

        to {
            max-width: 400px;
            opacity: 1;
        }
    }
    .order-history__order-detail-item {
        padding: 24px 24px 0px;
        width: 100%;
        overflow-y: scroll;
        max-height: calc(100% - 350px);

        .order-history__add-item {
            display: flex;
            gap: 6px;
            align-items: center;
            margin-top: 20px;
            cursor: pointer;
            p {
                font-weight: 800;
                color: #48d38a;
                text-decoration: underline;
            }
        }
    }
    @media (max-width: 414px) {
        @-webkit-keyframes slide-in-out {
            from {
                max-width: 70px;
                opacity: 0;
            }

            to {
                max-width: 351px;
                opacity: 1;
            }
        }

        @keyframes slide-in-out {
            from {
                max-width: 70px;
                opacity: 0;
            }

            to {
                max-width: 351px;
                opacity: 1;
            }
        }
    }
`;

export const OrderItemCardWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 0px 20px;
    width: 100%;
    border-bottom: 1px solid rgba(219, 220, 224, 0.5);
    :not(:first-child) {
        padding: 20px 0px;
    }
    h6 {
        span {
            color: #979797;
        }
    }
`;
